import FormInput from 'src/components/flows/common/FormInput';
import flowInput from 'src/components/flows/common/flowInput';

const FlowFormInput = flowInput(FormInput);

export default FlowFormInput;
